import { motion } from "motion/react"
import { FormattedMessage } from "react-intl";

export default function PageFour() {
    return (
        <motion.div
        className="mainScrollBaseContainer"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.5 }}
        >
            <div className="centered main heightCenter">
                <table className="comparisionTable">
                    <thead>
                        <tr>
                            <th><FormattedMessage id="version"/></th>
                            <th><FormattedMessage id="freeVersion"/></th>
                            <th><FormattedMessage id="proVersion"/></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><FormattedMessage id="maxAutoExpenses"/></td>
                            <td>5</td>
                            <td><FormattedMessage id="unlimited"/></td>
                        </tr>
                        <tr>
                            <td><FormattedMessage id="maxCategories"/></td>
                            <td>5</td>
                            <td><FormattedMessage id="unlimited"/></td>
                        </tr>
                        <tr>
                            <td><FormattedMessage id="maxHistMonths"/></td>
                            <td>6</td>
                            <td>24</td>
                        </tr>
                        <tr>
                            <td><FormattedMessage id="maxBankAcc"/></td>
                            <td>2</td>
                            <td><FormattedMessage id="unlimited"/></td>
                        </tr>
                        <tr>
                            <td><FormattedMessage id="adfreeOnMob"/></td>
                            <td><FormattedMessage id="no"/></td>
                            <td><FormattedMessage id="yes"/></td>
                        </tr>
                        <tr>
                            <td><FormattedMessage id="connectToDriveFromMob"/></td>
                            <td><FormattedMessage id="no"/></td>
                            <td><FormattedMessage id="yes"/></td>
                        </tr>
                    </tbody>
                </table>
                <div className="spacer"/>
                <div className="featureCard flexible"><FormattedMessage id="upgradeNotice"/></div>
            </div>
    
        </motion.div>
    );
}

/** table
 * max autoExpenses 5 - unlimited
 * max categories 5 - unlimited
 * max history in months 6 - 24
 * max bank accounts 2 - unlimited
 * adfree on mobile no - yes
 * connect to drive from mobile no - yes
 */